// extracted by mini-css-extract-plugin
module.exports = {"productEnquiryLanding":"ProductEnquiryView_productEnquiryLanding__ZMSM6"};